import min from 'lowscore/min.js'
import max from 'lowscore/max.js'

export const smallestImage = (images) => {
  var image = min(images, 'width')
  return image !== -Infinity && image
}

export const largestImage = (images) => {
  var image = max(images, 'width')
  return image !== -Infinity && image
}

export const imagesLargerThan = (images, width) => {
  return (images && images.filter(i => i.width >= width)) || []
}

export const imagesSmallerThan = (images, width) => {
  return (images && images.filter(i => i.width <= width)) || []
}

export const imagesWithName = (images, name) => {
  return (images && images.filter(image => image.name == name)) || []
}

export const imagesOfType = (images, type) => {
  return (images && images.filter(image => image.type == type)) || []
}